"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextArrayRenderer = void 0;
const react_1 = __importDefault(require("react"));
const Renderer_1 = require("@kyruus/rich-text/Renderer");
const RichTextStyleReset_styles_1 = require("../../common/styles/RichTextStyleReset.styles");
const CALLBACK_WAIT_TIME = 500;
const newLineFilter = new Renderer_1.LineBreakFilter({ type: 'collapse' });
const RichTextArrayRenderer = ({ id, content, onRichTextLinkClick }) => {
    if (!content)
        return null;
    const renderContent = content
        .map(({ label, value }, idx) => {
        if (value == null)
            return null;
        const labelId = `${id}-section-${idx}`;
        return `<section aria-labelledby="${labelId}"><strong id="${labelId}"}>${label}</strong>\n${value}</section>`;
    })
        .filter((v) => !!v)
        .join('\n');
    const handleRichTextLinkEvent = (e) => {
        if (!onRichTextLinkClick)
            return;
        const target = e.target;
        if (target instanceof HTMLAnchorElement &&
            target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
            onRichTextLinkClick(e, {
                content: target.textContent || '',
                href: target.href
            });
            // wait for the callback event
            setTimeout(() => {
                if (typeof window !== 'undefined' && target.href) {
                    window.location.href = target.href;
                }
            }, CALLBACK_WAIT_TIME);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key !== 'Enter')
            return;
        handleRichTextLinkEvent(e);
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    react_1.default.createElement("div", { onClick: handleRichTextLinkEvent, onKeyDown: handleKeyDown },
        react_1.default.createElement(RichTextStyleReset_styles_1.RichTextRenderer, { id: id, content: renderContent, filters: [newLineFilter] })));
};
exports.RichTextArrayRenderer = RichTextArrayRenderer;
//# sourceMappingURL=RichTextArrayRenderer.js.map